import React from 'react';
import { CheckIcon, ShieldIcon } from '@fronton/icons-react';
import { Section, Typography } from 'common/components';
import {
  serviceDescription,
  serviceDescriptionHeader,
  serviceDescriptionList,
  serviceDescriptionItem,
} from './service-description-styles';

export const ServiceDescription = () => (
  <Section className={serviceDescription}>
    <Typography className={serviceDescriptionHeader} variant="h2">
      Поможем вам с&nbsp;любым этапом работ или сделаем всё под ключ:
    </Typography>

    <ul className={serviceDescriptionList}>
      <li className={serviceDescriptionItem}>
        <CheckIcon strokeWidth={2} type="outline" size="m" color="text-secondary" />
        <Typography variant="m" size="body_long" color="text-secondary">
          замер помещения
        </Typography>
      </li>
      <li className={serviceDescriptionItem}>
        <CheckIcon strokeWidth={2} type="outline" size="m" color="text-secondary" />
        <Typography variant="m" size="body_long" color="text-secondary">
          сборка и установка кухонь
        </Typography>
      </li>
      <li className={serviceDescriptionItem}>
        <CheckIcon strokeWidth={2} type="outline" size="m" color="text-secondary" />
        <Typography variant="m" size="body_long" color="text-secondary">
          установка крана на мойку
        </Typography>
      </li>
      <li className={serviceDescriptionItem}>
        <CheckIcon strokeWidth={2} type="outline" size="m" color="text-secondary" />
        <Typography variant="m" size="body_long" color="text-secondary">
          установка и подключение бытовой техники
        </Typography>
      </li>
      <li className={serviceDescriptionItem}>
        <CheckIcon strokeWidth={2} type="outline" size="m" color="text-secondary" />
        <Typography variant="m" size="body_long" color="text-secondary">
          монтаж фильтров для воды под мойку
        </Typography>
      </li>
      <li className={serviceDescriptionItem}>
        <CheckIcon strokeWidth={2} type="outline" size="m" color="text-secondary" />
        <Typography variant="m" size="body_long" color="text-secondary">
          распил столешницы под нужный размер
        </Typography>
      </li>
    </ul>

    <div className={serviceDescriptionItem}>
      <ShieldIcon strokeWidth={2} type="duotone" size="m" color="text-secondary" />
      <Typography variant="m" size="body_long" color="text-secondary">
        Все услуги выполняют проверенные мастера от&nbsp;наших партнёров. Даём гарантию на&nbsp;услуги.
      </Typography>
    </div>
  </Section>
);
